import {BrightnessMediumTwoTone, DarkModeTwoTone, LightModeTwoTone} from "@mui/icons-material"
import {ToggleButton, ToggleButtonGroup, Tooltip} from "@mui/material"

import {SxPropsMap} from "../../../shared/helper/HelperType"
import {Mode, useSettings} from "../../../shared/provider/AppProvider"

const SX: SxPropsMap = {
    button: {padding: "3px 8px"},
}

export function SettingsThemeChanger() {
    const {state, setTheme} = useSettings()

    return (
        <ToggleButtonGroup value={state.mode}>
            <ToggleButton sx={SX.button} value={Mode.LIGHT} onClick={() => setTheme(Mode.LIGHT)}>
                <Tooltip title={Mode.LIGHT.toUpperCase()} placement={"top"}>
                    <LightModeTwoTone/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton sx={SX.button} value={Mode.SYSTEM} onClick={() => setTheme(Mode.SYSTEM)}>
                <Tooltip title={Mode.SYSTEM.toUpperCase()} placement={"top"}>
                    <BrightnessMediumTwoTone/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton sx={SX.button} value={Mode.DARK} onClick={() => setTheme(Mode.DARK)}>
                <Tooltip title={Mode.DARK.toUpperCase()} placement={"top"}>
                    <DarkModeTwoTone/>
                </Tooltip>
            </ToggleButton>
        </ToggleButtonGroup>
    )
}
